import React from "react";
import { StaticImage } from "gatsby-plugin-image"


const Logo = () => {
  return <StaticImage src="../../assets/img/logo.png" alt="Load and Go Logo" />
}

export default Logo;